<template>
  <div>
    <b-modal 
      ref="propsModal" 
      hide-header 
      centered 
      @show="propsShow" 
      :ok-only="!showButtons"
      :modalClass="'props-modal'"
      :hide-footer="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="noCloseOnEsc"
      @hide="propsHidden">
      <!-- <button @click="test">test</button> -->
      <p>{{$t('eduLimit')}}</p>
      <div v-if="propsList && propsList.length" class="props-frame">
        <b-card v-for="(prop, propIndex) in propsList" :key="propIndex" class="props-block">
          <button v-if="showButtons" type="button" aria-label="Close" class="close" :title="$t('delete')" style="color: red;" @click="propsList.splice(propIndex,1)">×</button>
          {{$t('eduName')}}
          <input :ref="'autocomplete'+propIndex" :name="'autocomplete'+propIndex" class="form-control" v-model="prop.name" @change="delete prop.googlePlace" :placeholder="$t('enterName')"/>
          {{$t('eduFaculty')}}
          <input type="text" class="form-control" v-model="prop.faculty" required="true" :disabled="!showButtons"/>
          {{$t('eduSpecialization')}}
          <input type="text" class="form-control" v-model="prop.specialization" required="true" :disabled="!showButtons"/>
          {{$t('eduYOE')}}
          <input type="number" class="form-control" v-model="prop.yearOfEnding" required="true" :disabled="!showButtons"/>
        </b-card>
      </div>
      <div class="props-footer">
        <div class="footer-btns">
          <div class="force-left">
            <button v-if="showButtons" class="btn btn-info btn-fill btn-add-props" @click="addProps()">{{$t('add')}}</button>
          </div>
          <div class="force-right">
            <button ref="cancel" class="btn btn-secondary btn-fill btn-props" @click="$refs.propsModal.hide()">{{$t('props_close')}}</button>
            <button v-if="showButtons" class="btn btn-primary btn-fill btn-props" @click="handleOk($event)">{{$t('props_apply')}}</button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import gallery from 'gallery-vue';
  import swal from 'sweetalert2';
  import cloneDeep from 'clone-deep';
  import { USER_GALLERY_IMAGE } from "../store/actions/userConst"
  import { mapActions, mapGetters } from 'vuex';
  import UniversalModal from "../components/UniversalModal";
  import {GOOGLE_GET_PLACE} from "../store/actions/langConst"

  export default {
    components: { gallery, UniversalModal },
    props: {
      propsList: {},
      modalShow: false,
      showButtons: true,
    },
    data() {
      return {
        noCloseOnEsc: false,
        gPlace: null,
        RxGooglePointer: null,
        okClick: false,
        propsBuf: [],
      }
    },
    beforeDestroy() {
      this.RxGooglePointer.unsubscribe()
    },
    mounted() {
      this.RxGooglePointer = this.RxGoogle.subscribe(gPlace=>{
        if(gPlace) {
          this.gPlace = gPlace;
        } else {
          console.log('Google autocomplete not laded!' );
        }
      });
    },
    watch: {
      modalShow(val) {
        if(val) {
          this.$refs.propsModal.show();
          setTimeout(()=>this.addAutocomplete(),0);
        } else {
          this.RxGooglePointer.unsubscribe()
        }
      },
    },
    computed: {
      ...mapGetters(['getUserProfile','RxGoogle','currentLng'])
    },
    methods: {
      ...mapActions([USER_GALLERY_IMAGE,GOOGLE_GET_PLACE]),
      test() {
        this.$refs.cancel.click();
      },
      addAutocomplete() {
        if(this.gPlace && this.propsList && this.propsList.length) {
          this.propsList.forEach((element, index) => {
            if(!element.autocomplete) {
              element.autocomplete = new this.gPlace.Autocomplete(this.$refs['autocomplete'+index][0], {types: ['establishment']});
              element.autocomplete.addListener('place_changed', ()=>{
                let place = element.autocomplete.getPlace();
                element.googlePlace = place.place_id;
                element.name = place.name;
              });
            }
            if(element.googlePlace && !(element.googlePlaceLocales && element.googlePlaceLocales[this.currentLng])) {
              this.GOOGLE_GET_PLACE({place_id: element.googlePlace, language: this.currentLng})
                .then(place=>{
                  element.googlePlaceLocales = element.googlePlaceLocales || {};
                  element.googlePlaceLocales[this.currentLng] = place.name;
                  element.name = place.name;
                  this.propsList.push({});
                  this.propsList.splice(this.propsList.length-1,1);
                  this.propsShow();
                })
                .catch(err=>console.log(err))
            }
          });
        }  
      },
      deleteProp(prop, propIndex) {
        if(prop.added) {
          this.propsList.splice(propIndex,1)
        } else {
          prop.deleted=true
          this.propsList.unshift({})
          this.propsList.splice(0,1)
        }
      },
      propsShow() {
        this.propsBuf = cloneDeep(this.propsList);
        if (!this.propsList.length) {
            this.propsList.push({});
            setTimeout(()=>this.addAutocomplete(),0);
        }
      },
      propsHidden() {
        if(this.okClick) {
          this.okClick = false;
        } else {
          this.$emit('props-update',this.propsBuf)
        }
        this.$emit('props-close')
      },
      handleOk(evt) {
        let unValidateProps = this.propsList.filter(p=>(!p.name || !p.name.length) && !p.googlePlace)
        if(unValidateProps.length) {
          evt.preventDefault();
          this.noCloseOnEsc = true;
          swal.fire({
            text: this.$t('eduText1'),
            type: 'error',
          }).then(()=>this.noCloseOnEsc = false);
        } else {
          this.okClick = true;
          this.propsList.sort((a,b)=>{
            let aa = a.yearOfEnding || 0;
            let bb = b.yearOfEnding || 0;
            return (aa > bb ? -1 : 1)
          });
          this.$refs.propsModal.hide();
        }
        this.$emit('props-close');
      },
      addProps() {
        if(this.propsList.length<5) {
          this.propsList.push({});
          setTimeout(()=>this.addAutocomplete(),0);
        } else {
          this.noCloseOnEsc = true;
          swal.fire({
            text: this.$t('eduLimit'),
            type: 'error',
          }).then(()=>this.noCloseOnEsc = false);
        }
      },
    },
  }
</script>

<style>
.props-modal > div {
    position: fixed;
    left: 0; right: 0;
    top: 0px;
}
.props-modal .modal-content {
    opacity: 1 !important;
    position: absolute !important;
}
@media only screen and (max-width: 768px) {
    .props-modal {
      padding: 0 !important;
    }
    .props-modal .modal-dialog {
      margin: 0 !important;
    }
}
</style>

<style scoped>
.header-info {
  display: inline-block;
  margin-bottom: 0px;
}
.btn-add-props {
  background-color: #FB404B !important;
  border-color: #FB404B !important;
  font-weight: 500 !important;
  display: inline-block;
  height: 30px;
  padding: 0;
  padding-left: 10px;
  padding-right: 10px;
}
.btn-props {
  font-weight: 500 !important;
  display: inline-block;
  height: 30px;
  padding: 0;
  padding-left: 10px;
  padding-right: 10px;
}
.subscription h1 {
    text-align: right;
}
.image-select-view {
  width: 100px;
  height: 100px;
  background-color: grey;
  cursor: pointer;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  padding: 8px;
  border-radius: 0.25rem;
  color: #efefef;
  text-shadow: 1px 1px 1px #000000d6;
}
.image-select {
  margin-top: 10px;
}
.props-footer {
  margin-top: 10px;
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}
.footer-btns {
  margin-top: 10px;
}
.footer-btns .btn-secondary {
  margin-right: 5px;
}
.label-size {
  margin-top: 5px;
  margin-bottom: 5px;
  text-align: center;
}
.close {
  color: red;
  position: relative;
  top: -8px;
}
.props-block {
  margin-bottom: 10px;
}
.props-frame {
  min-height: 200px;
  max-height: 445px;
  overflow-y: auto;
  margin-top: 1em;
}
.attached-img {
  max-width: 100px;
  max-height: 100px;
  cursor: pointer;
  border-radius: 4px;
}
::-webkit-scrollbar {
  width: 8px
}
@media only screen and (max-width: 768px) {
    .subscription h1 {
        text-align: center;
    } 
  .props-frame {
    height: calc(100vh - 220px);
  }
}
</style>

